export default "__VITE_ASSET__71feb726__"